import React from "react";
import { useEffect, useState, useRef } from "react";
import "./propertiesagency.css";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import SelectBox from "../../../src/input-components/selectBoxNew";
import { updatetenantfoliodetails,addnewtenancy } from "../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import TextBox from "../../../src/input-components/textbox";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus, eTenantAgreementTerm } from "../../../Utilities/enum";
import { rentDetails } from "../../../components/CommonSection/Schema/schema";
import { dynamicUrl } from "../../../Utilities/profileManagement";
import { BiDollar } from "react-icons/bi";
import { Select, Spin } from "antd";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";

const initialValues = {
  Rent: null,
  Period: null,
  RentIncludeTax: false,
  BondAmount: "",
  BondInTrust: "",
  AgreementStart: "",
  AgreementEnd: "",
  Deposited: "",
  Balance: "",
  RentReviewFrequency: 12,
  IsCommercial: "",
  ABN: "",
  tenantTerm: 0,
  MoveInDate: "",
  MoveOutDate: "",
  tenancyType: "",
  rentInvoiceStatus: false,
  invoiceDaysInAdvance: "",
  DatePaidTo:""
};

const TenantFolio = ({ onDataRecive, handleparentsuccess, getDetails, handleCurrentPage, tabChange, cancel,manageTenant,tenantFormData }) => {
  console.log(getDetails,'getDetails')
  const [userId, setUserId] = useState("");
  const [agentId, setAgentId] = useState("");
  const [agencyID, setAgencyId] = useState("");
  const navigate = useNavigate();
  const { showSpinner, hideSpinner } = useSpinnerContext();
  var url = new URL(window.location.href);
  const ToastRef = useRef();
  const [isCommercialData, setIsCommercialData] = useState([
    { label: "Yes", value: true },
    { label: "No", value: false },
  ]);
  const [periodData, setPeriodData] = useState([
    { label: "Weekly", value: 1 },
    { label: "Monthly", value: 2 },
  ]);

  const [rentIncludeTaxData, setRentIncludeTaxData] = useState([
    { label: "Yes", value: true },
    { label: "No", value: false },
  ]);

  const tenantTerms = [
    { label: '6 months', value: eTenantAgreementTerm.SixM },
    { label: '12 months', value: eTenantAgreementTerm.TwelveM },
    { label: '2 years', value: eTenantAgreementTerm.TwoY },
    { label: '3 years', value: eTenantAgreementTerm.ThreeY },
    { label: '5 years', value: eTenantAgreementTerm.FiveY },
    { label: 'Periodic (no end date)', value: eTenantAgreementTerm.Periodic },
    { label: 'Other (Please specify)', value: eTenantAgreementTerm.Other },
  ];

  useEffect(() => {
    const retrieveData = async () => {
      try {
        const userData = GetCookie("@UserData");
        if (userData) {
          const parsedData = JSON.parse(userData);
          setUserId(parsedData.userId);
          setAgentId(parsedData.agentId);
           setAgencyId(parsedData.agencyID);
        }
      } catch (error) {
        console.error("Error retrieving data from AsyncStorage:", error);
      }
    };
    retrieveData();
  }, [userId]);

  

  useEffect(() => {
    if (getDetails) {
      let ownerListData = getDetails.tenantDetails ? getDetails.tenantDetails : [];
      setFieldValue("Rent", ownerListData[0]?.tenantFolioDetails.rent);
      setFieldValue("Period", ownerListData[0]?.tenantFolioDetails.period);
      setFieldValue("IsCommercial", ownerListData[0]?.tenantFolioDetails.isCommercial);
      setFieldValue("RentIncludeTax", ownerListData[0]?.tenantFolioDetails.rentIncludeTax ? ownerListData[0]?.tenantFolioDetails.rentIncludeTax : false);
      setFieldValue("Deposited", ownerListData[0]?.tenantFolioDetails.deposited);
      setFieldValue("Balance", ownerListData[0]?.tenantFolioDetails.balance);
      setFieldValue("RentReviewFrequency", ownerListData[0]?.tenantFolioDetails.rentReviewFrequency ? ownerListData[0]?.tenantFolioDetails.rentReviewFrequency : 12);
      setFieldValue("ABN", ownerListData[0]?.tenantFolioDetails.abn);
      setFieldValue("AgreementStart", formatDate(ownerListData[0]?.tenantFolioDetails.agreementStart));
      setFieldValue("AgreementEnd", formatDate(ownerListData[0]?.tenantFolioDetails.agreementEnd));
      setFieldValue("BondAmount", ownerListData[0]?.tenantFolioDetails.bondAmount);
      setFieldValue("BondInTrust", ownerListData[0]?.tenantFolioDetails.bondInTrust);
      setFieldValue("MoveInDate", formatDate(ownerListData[0]?.tenantFolioDetails.moveIn));
      setFieldValue("MoveOutDate", formatDate(ownerListData[0]?.tenantFolioDetails.moveOut));
      setFieldValue("tenantTerm", ownerListData[0]?.tenantFolioDetails.agreementTerm);
      setFieldValue("DatePaidTo", formatDate(ownerListData[0]?.tenantFolioDetails.datePaidTo));

    }
  }, [getDetails])

  function formatDate(dateString) {
    if (!dateString) {
      return "";
    }
    const [year, month, day] = dateString.split("T")[0].split("-");
    return `${year}-${month}-${day}`;
  }

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: rentDetails,
    onSubmit: (values, action) => {
      handleFinalSubmit();
    },
  });


const handleFinalSubmit = () => {
  // 1. Build TenantFolioDetails object
  const tenantFolioDetails = {
    Id: manageTenant ? 0 : getDetails?.tenantDetails?.[0]?.tenantFolioDetails?.id,
    Rent: parseFloat(values.Rent),
    Period: values.Period ? parseInt(values.Period) : null,
    RentIncludeTax: values.RentIncludeTax,
    BondAmount: values.BondAmount ? parseFloat(values.BondAmount) : 0,
    BondInTrust: values.BondInTrust ? parseFloat(values.BondInTrust) : 0,
    AgreementStart: values.AgreementStart,
    AgreementEnd: values.AgreementEnd,
    Deposited: values.Deposited ? parseFloat(values.Deposited) : 0,
    Balance: values.Balance ? parseFloat(values.Balance) : 0,
    RentReviewFrequency: values.RentReviewFrequency,
    IsCommercial: values.IsCommercial,
    ABN: values.ABN,
    UserId: userId,
    MoveIn: values.MoveInDate,
    MoveOut: values.MoveOutDate,
    TenancyType: values.tenancyType,
    RentInvoice: values.rentInvoiceStatus,
    InvoiceDaysInAdvance: parseInt(values.invoiceDaysInAdvance || 0),
    AgreementTerm: values.tenantTerm,
    DatePaidTo: values.DatePaidTo,
    ...(manageTenant && { NewTenant: true })
  };

  // 2. Extract Tenants from tenantFormData if manageTenant
  const tenantList = manageTenant && tenantFormData?.Tenants?.length > 0
    ? tenantFormData.Tenants
    : [];

  // 3. Construct final payload
  const payload = {
    AgencyId: agencyID,
    AgentId: agentId,
    TenantFolioDetails: tenantFolioDetails,
    Tenants: tenantList,
    PropertyId : getDetails.propertyId
  };

  let finalPayload = manageTenant ? payload : tenantFolioDetails
  let url = manageTenant ? addnewtenancy:updatetenantfoliodetails

  // 4. Post to API
  makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalPayload)
    .then((returnData) => {
      if (returnData.status === ActionStatus.Successfull) {
        ToastRef.current.notify(["success", returnData.message]);
        debugger
        setTimeout(() => {
        tabChange(propertyUId, "Payment Method",returnData.sUID);

        },500);
      } else {
        ToastRef.current.notify(["error", returnData.message]);
      }
    })
    .catch((error) => {
      ToastRef.current.notify(["error", returnData.message]);
    });
};


  useEffect(() => {
    agentUIDRef.current = agentId;
  }, [agentId]);

  const agentUIDRef = useRef(agentId);
  var url = new URL(window.location.href);
  var propertyUId = url.searchParams.get("propertyUID");
  const handleCancel = () => {

    if (propertyUId) {
      handleCurrentPage("Overview")
    } else {
      dynamicUrl(navigate, "propertiesList");
    }
  };

  const handleChangeRent = (val) => {
    setFieldValue("Rent", val.target.value)
    setFieldValue("BondAmount", val.target.value * 4)
  }

  const handleChangeTenantTerm = (e) => {
    setFieldValue("tenantTerm", e.value)
    setFieldValue("AgreementStart", '');
    setFieldValue("AgreementEnd", '');
  }

  const handleChangePaidDate = (e) => {
    const dateValue = e.target.value;
    setFieldValue("DatePaidTo",dateValue)
  }

  const handleChangeDate = (e) => {
    const dateValue = e.target.value;
    setFieldValue("AgreementStart", dateValue);
    setFieldValue("MoveInDate", dateValue)

    const startDate = new Date(dateValue);
    const endDate = new Date(startDate);

    // Calculate the number of weeks based on TermsAgreement
    const weeksToAdd = {
      '1': 26, // 6 months = 26 weeks
      '2': 52, // 12 months = 52 weeks
      '3': 104, // 24 months = 104 weeks
      '4': 156, // 36 months = 156 weeks
      '5': 260, // 60 months = 260 weeks
    }[values.tenantTerm];

    if (weeksToAdd !== undefined) {
      // Add the calculated number of weeks to the start date
      endDate.setDate(startDate.getDate() + weeksToAdd * 7);

      // Format the end date as YYYY-MM-DD
      const formattedEndDate = endDate.toISOString().slice(0, 10);

      // Set AgreementEnd value
      setFieldValue("AgreementEnd", formattedEndDate);
    }
  }

  return (
    <div>
    <ToastAlert ref={ToastRef} />
      <form onSubmit={handleSubmit}>
        <div className="contacts-group row">
          <TextBox
            isMandatory
            label={"Rent"}
            placeholder={"Rent"}
            name="Rent"
            value={values.Rent}
            onChange={(e) => handleChangeRent(e)}
            onBlur={handleBlur}
            error={errors.Rent}
            touched={touched.Rent}
            icon={
              <BiDollar height="100%" width="100%" />
            }
          />
          <div className="col-12 col-lg-6 col-md-6 col-sm-6">
            <div style={{ display: "flex", gap: "15px", alignItems: "center", marginTop: "40px" }}>
              <label style={{ display: 'flex', alignItems: 'center', fontFamily: 'inter', color: 'gray', fontWeight: '500' }}>
                <input
                  type="checkbox"
                  name="RentIncludeTax"
                  value="true"
                  checked={values.RentIncludeTax}
                  onChange={() => setFieldValue("RentIncludeTax", !values.RentIncludeTax)}
                  className="mr-2"
                />
                Tax Inc
              </label>
            </div>
          </div>
          <SelectBox
            isMandatory
            label={"Period"}
            placeholder="Period"
            name="Period"
            options={periodData}
            value={values.Period}
            onChange={(val) =>
              setFieldValue("Period", val.value)
            }
            onBlur={handleBlur}
            error={errors.Period}
            touched={touched.Period}
          />
          <TextBox
            label={"Bond Amount"}
            placeholder="Bond Amount"
            name="BondAmount"
            value={values.BondAmount}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.BondAmount}
            touched={touched.BondAmount}
            icon={
              <BiDollar height="100%" width="100%" />
            }
          />
          <TextBox
            label={"Bond In Trust"}
            placeholder="Bond In Trust"
            name="BondInTrust"
            value={values.BondInTrust}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.BondInTrust}
            touched={touched.BondInTrust}
            icon={
              <BiDollar height="100%" width="100%" />
            }
          />
          <SelectBox
            label={"Agreement Term"}
            placeholder="Select Agreement Term"
            name="tenantTerm"
            options={tenantTerms}
            value={values.tenantTerm}
            onChange={(e) => handleChangeTenantTerm(e)}
            onBlur={handleBlur}
            error={errors.tenantTerm}
            touched={touched.tenantTerm}
            // readOnly={getDetails?.tenantFolioDetails?.datePaidTo ? true : false}

          />
          <TextBox
            isMandatory
            label="Agreement Start"
            name="AgreementStart"
            type="date"
            value={values.AgreementStart}
            onChange={(e) => handleChangeDate(e)}
            onBlur={handleBlur}
            error={errors.AgreementStart}
            touched={touched.AgreementStart}
            //readOnly={getDetails?.tenantFolioDetails?.datePaidTo ? true : false}
          />
          <TextBox
            isMandatory
            label="Agreement End"
            name="AgreementEnd"
            type="date"
            value={values.AgreementEnd}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.AgreementEnd}
            touched={touched.AgreementEnd}
                        readOnly={getDetails?.tenantFolioDetails?.datePaidTo ? true : false}

          />
          <TextBox
            label="Move-in Date"
            name="MoveInDate"
            type="date"
            value={values.MoveInDate}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.MoveInDate}
            touched={touched.MoveInDate}
          />

          <TextBox
            label="Move-out Date"
            name="MoveOutDate"
            type="date"
            value={values.MoveOutDate}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.MoveOutDate}
            touched={touched.MoveOutDate}
          />
          <TextBox
            label={"Deposited"}
            placeholder="Deposited"
            name="Deposited"
            value={values.Deposited}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.Deposited}
            touched={touched.Deposited}
            icon={
              <BiDollar height="100%" width="100%" />
            }
            readOnly={true}
          />
          <TextBox
            label={"Balance"}
            placeholder="Balance"
            name="Balance"
            value={values.Balance}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.Balance}
            touched={touched.Balance}
            icon={
              <BiDollar height="100%" width="100%" />
            }
            readOnly={true}
          />
          <TextBox
            label={"Rent Review Frequency"}
            placeholder="Rent Review Frequency"
            name="RentReviewFrequency"
            value={values.RentReviewFrequency}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.RentReviewFrequency}
            touched={touched.RentReviewFrequency}
          />
          <SelectBox
            label={"Is Commercial"}
            placeholder="Is Commercial "
            name="IsCommercial "
            options={isCommercialData}
            value={values.IsCommercial}
            onChange={(val) =>
              setFieldValue("IsCommercial", val.value)
            }
            error={errors.IsCommercial}
            touched={touched.IsCommercial}
          />
          <TextBox
            label={"ABN"}
            placeholder="ABN"
            name="ABN"
            value={values.ABN}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.ABN}
            touched={touched.ABN}
          />
          {/* Tenancy Type */}
          <div className="col-lg-6 col-sm-12">
            <label className="s1">Tenancy Type</label>
            <Select
              style={{ width: "100%", height: "40px" }}
              placeholder="Select Tenancy Type"
              value={values.tenancyType}
              onChange={(val) => setFieldValue("tenancyType", val)}
              options={[
                { label: "Fixed", value: 1 },
                { label: "Periodic", value: 2 },
              ]}
            />
          </div>

          {/* Rent Invoice */}
          <div className="col-lg-6 col-sm-12">
            <label className="s1">Rent Invoice</label>
            <Select
              style={{ width: "100%", height: "40px" }}
              placeholder="Select Rent Invoice Status"
              value={values.rentInvoiceStatus}
              onChange={(val) => setFieldValue("rentInvoiceStatus", val)}
              options={[
                { label: "Active", value: true },
                { label: "Inactive", value: false },
              ]}
            />
          </div>

          {/* Invoice Days in Advance */}
          {values.rentInvoiceStatus === true && (
            <TextBox
              label="Invoice Days in Advance"
              type="number"
              name="invoiceDaysInAdvance"
              value={values.invoiceDaysInAdvance}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.invoiceDaysInAdvance}
              touched={touched.invoiceDaysInAdvance}
            />
          )}
          <TextBox
            label="Date Paid To"
            name="DatePaidTo"
            type="date"
            value={values.DatePaidTo}
            onChange={(e) => handleChangePaidDate(e)}
            onBlur={handleBlur}
            error={errors.DatePaidTo}
            touched={touched.DatePaidTo}
          //readOnly={getDetails?.tenantFolioDetails?.datePaidTo ? true : false}
          />
        </div>
        <div className="property-details-buttons">
          <button
            className="pdb-cancel"
            type="reset"
            onClick={cancel}
          >
            Cancel
          </button>
          <button className="pdb-save-changes" type="submit">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default TenantFolio;
